// eslint-disable-next-line import/prefer-default-export
export const getPlatformInvoices = (state) => state.platformInvoices;
